import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { CommonService } from 'src/providers/common';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { ServicesProvider } from 'src/providers/services';
import 'rxjs/add/operator/map'
//import { AlertService } from 'src/providers/alert';
//import { VideoEditor,CreateThumbnailOptions } from '@ionic-native/video-editor/ngx';

import 'rxjs/Rx';
import { AlertController, Platform } from '@ionic/angular';
//import { resolve } from 'node:dns';
@Injectable()
export class FileUploadService {



  public uploadComplete: boolean = true;
  public fileUploaded: boolean = false;
  public thumbnailUploaded: boolean = true;
  public filepath: any; thumbnailpath; any; fileList = [];
  allowedTypes = ["application/pdf", "image/jpeg", "image/png", "video/mp4", "video/quicktime", "audio/mp4", "audio/mp3", "audio/mpeg", "audio/m4a", "audio/x-m4a"];
  docpath: any;
  cameraImage: any[] = [];
  privatePathUrl: any;
  constructor(public common: CommonService,/* private videoEditor: VideoEditor,*/private platform: Platform, public alertCtrl: AlertController,/*public alrtService:AlertService,*/private services: ServicesProvider, public file: File, public camera: Camera) {

  }

  openCamera() {
    //var returnData;
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: true,
      saveToPhotoAlbum: true,
      targetWidth: 600,
      targetHeight: 600,
      correctOrientation: true,
    }
    return new Promise((resolve, reject) => {
      this.camera.getPicture(options).then((imageData) => {
        this.uploadComplete = false;
        let fileContents = this.b64toBlob(imageData, "image/jpg");
        let fileName = new Date().getTime() + String(Math.floor(Math.random() * 10000)) + localStorage.getItem("Doctor_ID") + ".jpg";
        console.log(fileContents);
        resolve([imageData, fileName]);
        this.uploadImagetoSever([fileContents, fileName], "1");
      }, (err) => {
        this.uploadComplete = true;
        resolve(["0", ""]);
      });
    });
  }

  dataBinary: any;
  fileURl: any;
  openCameras(type) {
    //var returnData;
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true,
      // allowEdit: true,
      // saveToPhotoAlbum: true,
      // targetWidth: 600,
      // targetHeight: 600,
    }
    return new Promise((resolve, reject) => {
      this.camera.getPicture(options).then(async (imageData) => {
        this.uploadComplete = false;
        console.log(imageData, "options-data");
        // this.fileURl = await this.blobToUint8Array(imageData);
        this.fileURl = await this.b64toBlob(imageData, "image/jpg");
        let fileName = new Date().getTime() + String(Math.floor(Math.random() * 10000)) + localStorage.getItem("patient_id") + ".jpg";
        console.log(fileName, "fileNameone");
        console.log('Binary  this.fileURl:', this.fileURl);
        this.cameraImage = [this.fileURl, fileName];
        if (type == "1") {

          // const formData = new FormData();
          // formData.append('dataFile', imageData);

          // this.services.imageUploadServer("uploadfile", formData).subscribe(response => {
          //   console.log("resposeeehhhhhuploadimageblobToBinary", response);
          //   this.filepath = response.file.path;
          //   console.log("resposeeehhhhhuploadimagefilepath", this.filepath);
          //   resolve(["https://uploadtestapi.theonemoment.com/" + response.file.path, fileName]);
          // });
          const formData = new FormData();
          formData.append('module_id', "66");
          formData.append('file', this.cameraImage[0], this.cameraImage[1]);
          formData.append('pathLocation', "PROFILE/");
          
          this.services.imageUploadS3Bucket("admin/awsS3FileUpload", formData).subscribe(response => {
            debugger;
            this.filepath = response.filepath.Location;
            this.privatePathUrl = response.filepath.privatePathUrl;
            resolve([this.filepath, fileName ,  this.privatePathUrl]);
            console.log("Uploaded file path: ", this.filepath);
            console.log("Uploaded file Private path: ", this.privatePathUrl);
          });
        }
      }, (err) => {
        this.uploadComplete = true;
        console.log(err, "error-msg");
        resolve(["0", ""]);
      });
    });
  }


  blobToUint8Array(blob: any) {
    return new Promise(async (resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(blob).then((fileEntry: any) => {
        console.log(fileEntry, "fileEntry");
        fileEntry.file(function (file) {
          resolve(file);
          console.log(file, "file------binary");
        })
      })
    });
    // return new Promise<string>((resolve, reject) => {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     const binaryData = reader.result as string;
    //     const filePath = this.file.dataDirectory + filename;
    //     blob["name"] = "TOM-FileUpload-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + ".jpg";
    //     blob["webkitRelativePath"] = "";
    //     blob["lastModifiedDate"] = new Date();
    //     blob["lastModified"] = new Date();
    //     var filename = "TOM-FileUpload-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + "png";;
    //     // var audioFile = new File([blob], filename);
    //     this.file
    //       .writeFile(this.file.dataDirectory, filename, binaryData, {
    //         replace: true,
    //       })
    //       .then(() => {
    //         // resolve(new File([blob], filename));
    //         console.log("filePath--binary", filePath);
    //         this.readBinaryFile(filePath);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   };

    //   reader.readAsBinaryString(blob);
    // });
    // ----------------------------
    // fileContents["name"] = "TOM-FileUpload-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + ".jpg";
    // fileContents["webkitRelativePath"] = "";
    // fileContents["lastModifiedDate"] = new Date();
    // fileContents["lastModified"] = new Date();
    // var filename = "TOM-FileUpload-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + "png";;

    // return new File(
    //   [fileContents as any], filename, {
    //   lastModified: new Date().getTime(), 
    //   type: fileContents.type
    // });
  }
  getFiles(type) {
    return new Promise(async (resolve, reject) => {
      this.openGallery().then(gallerydata => {
        this.uploadComplete = false;
        this.fileUploaded = false;
        let uri;
        if (String(gallerydata[1]).includes("file:///") == false) {
          uri = "file:///" + gallerydata[1];
        } else {
          uri = gallerydata[1];
        }
        if (gallerydata[0] != "0") {
          console.log(uri, "check uri ===================================>");

          this.validateFile(uri).then(result => {
            if (result[0] == "1") {
              let fileName = result[1];
              let fileType = result[2];
              if (type != "2" && type != "4") {
                resolve(["1", fileName, fileType]);
              }

              //  this.thumbnailUploaded= true;
              /*  if(from=="MD" && fileType.includes("video")){
                  this.thumbnailUploaded= false;
                  this.getVideoThumbnail(uri);
                }*/
              this.readFile(uri).then(filedata => {
                if (filedata[0] == "1") {
                  if (type != "1") {
                    //resolve([uri, fileName, fileType]);
                    resolve([filedata[1], fileName, fileType]);
                  }
                  this.uploadImagetoSever([filedata[1], fileName], type);
                } else {
                  resolve(filedata);
                }
              })
            } else {
              resolve(result);
            }
          })
        } else {
          resolve(gallerydata);
        }
      })
    });
  }

  readFile(filePathValue) {
    return new Promise(async (resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(filePathValue)
        .then(entry => (<FileEntry>entry).file(file => {
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onloadend = () => {
            const imgBlob = new Blob([reader.result], { type: file.type });
            resolve(["1", imgBlob]);
          }
        })).catch(async err => {
          console.log("Error1");
          this.uploadComplete = true;
          console.log(err);
          resolve(["0", "Can't Fetch File"]);
        });
    });
  }

  validateFile(filePathValue) {
    // return new Promise(async (resolve, reject) => {
    //   this.file.resolveLocalFilesystemUrl(filePathValue).then((fileEntry: any) => {
    //     console.log(fileEntry);
    //     let fileName = fileEntry.name;
    //     var ref = this;
    //     fileEntry.file(function (file) {
    //       if (file.size <= 10485760) {
    //         console.log("file type====", file.type);

    //         if (ref.allowedTypes.indexOf(file.type) > -1) {
    //           if (fileName.split(".").length <= 1) {
    //             fileName = fileName + ref.getMIMEtype(file.type);
    //           }
    //           resolve(["1", fileName, file.type]);
    //         } else {
    //           ref.uploadComplete = true;
    //           resolve(["0", "UnSupported File Type!"]);
    //         }
    //       } else {
    //         ref.uploadComplete = true;
    //         resolve(["0", "File size is greater than 10MB!"]);
    //       }
    //     });
    //   }).catch((error: any) => {
    //     this.uploadComplete = true;
    //     console.error(error);
    //     console.log(error);
    //     resolve(["0", "Can't Fetch File!"]);
    //   });
    // });
    return new Promise(async (resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(filePathValue).then((fileEntry: any) => {
        console.log(fileEntry);
        let fileName = fileEntry.name;
        var ref = this;
        fileEntry.file(function (file) {
          if (file.size <= 10485760) {
            if (ref.allowedTypes.indexOf(file.type) > -1) {
              if (fileName.split(".").length <= 1) {
                fileName = fileName + ref.getMIMEtype(file.type);
              }
              resolve(["1", fileName, file.type]);
            } else {
              ref.uploadComplete = true;
              resolve(["0", "UnSupported File Type!"]);
            }
          } else {
            ref.uploadComplete = true;
            resolve(["0", "File size is greater than 10MB!"]);
          }
        });
      }).catch((error: any) => {
        this.uploadComplete = true;
        console.log("Error2" + error);
        resolve(["0", "Can't Fetch File!"]);
      });
    });
  }

  getVideoThumbnail(uri) {
    /* let thumbnailoption : CreateThumbnailOptions = {
       fileUri:uri,
       quality:100,
       atTime:1,
       outputFileName: 'thumbnailImage',
   }
   console.log("=====================================");
   this.videoEditor.createThumbnail(thumbnailoption).then((thumbnailPath)=>{
     let path;
     if(String(thumbnailPath).includes("file:///")==false){
         path="file:///"+thumbnailPath;
       }else{
         path= thumbnailPath;
       }
     this.validateFile(path).then(result=>{
       let fileName= result[1];
     this.readFile(path).then(filedata=>{
       let formData= new FormData();
       formData.append("file",filedata[1], fileName);
      this.services.imageUpload("uploadImageSingle", formData).subscribe(response=>{
        this.thumbnailpath= response.filename;
         this.thumbnailUploaded= true;
         if(this.fileUploaded==true){
           this.uploadComplete= true;
         }
      });
     });
   });
   }).catch((err)=>{
     this.thumbnailUploaded= true;
     if(this.fileUploaded==true){
       this.uploadComplete= true;
     }
     console.log("Thumbnail Responce Error=>",err)
   
   })*/
  }


  openGallery() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.FILE_URI,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: true
    }
    return new Promise((resolve, reject) => {
      this.camera.getPicture(options).then((imageData) => {
        console.log(imageData)
        resolve(["1", imageData]);
      }).catch((error: any) => {
        this.uploadComplete = true;
        console.error("Error3" + error);
        resolve(["0", "Can't Fetch File!"]);
      });
    });
  }



  getFileFromUrl(url) {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then(res => {
          res.blob().then(blob => {
            resolve(blob);
          })
        });
    });
  }

  uploadImagetoSever(file, type) {
    let formData = new FormData();
    formData.append("file", file[0], file[1]);
    this.services.imageUpload("uploadImageSingle", formData).subscribe(response => {
      console.log(response);
      this.uploadComplete = true;
      /*  if(this.thumbnailUploaded==true){
          this.uploadComplete= true;
        }*/
      // this.filepath= response.imgname;

      if (type == "4") {
        this.fileList.push(response.filename);
      } else {
        this.filepath = response.filename;
      }
      // this.alrtService.showToast("File Slelected!", 2000);
      if (type == "3") {
        let alert = this.alertCtrl.create({
          //header: localStorage.getItem("AlertHeader"),
          message: "File Selected!",
          mode: 'ios',
          cssClass: 'popup-login',
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
              }
            }

          ]
        }).then(alert => alert.present());
      }
    });
  }



  getfilepath() {
    return this.filepath;
  }

  getfilepath1() {
    return this.filepath;
  }

  getthumbpath() {
    return this.thumbnailpath;
  }

  setthumb(path) {
    this.thumbnailpath = path;
  }

  setfilepath(path) {
    this.filepath = path;
    this.uploadComplete = true;
  }

  getUploadStatus() {
    return this.uploadComplete;
  }

  getMIMEtype(extn) {
    let ext = extn.toLowerCase();
    let MIMETypes = {
      'image/jpg': '.jpg',
      'image/jpeg': '.jpeg',
      'image/bmp': '.bmp',
      'image/png': '.png',
      'video/mp4': '.mp4',
      'video/x-msvideo': '.avi',
      'video/quicktime': '.mov',
      'audio/mp4': '.mp4',
      'audio/mp3': '.mp3',
      'audio/mpeg': '.mpeg',
      "audio/m4a": ".m4a"
      /* 'txt' :'text/plain',
       'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
       'doc' : 'application/msword',
       'pdf' : 'application/pdf',
       'jpg' : 'image/jpeg',
       'jpeg' : 'image/jpeg',
       'bmp' : 'image/bmp',
       'png' : 'image/png',
       'mp4' : 'video/mp4',
       'avi' : 'video/x-msvideo'
       'xls' : 'application/vnd.ms-excel',
       'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
       'rtf' : 'application/rtf',
       'ppt' : 'application/vnd.ms-powerpoint',
       'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'*/
    }
    return MIMETypes[ext];
  }


  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  removeFile(index) {
    this.fileList.splice(index, 1);
  }

  getFileList() {
    if (this.fileList)
      return JSON.stringify(this.fileList);
    else
      return "";
  }


  uploadAudio(uri) {
    // return new Promise(async (resolve, reject) => {
    //   try {
    //     // this.openGallery(from).then(gallerydata => {
    //     this.uploadComplete = false;
    //     this.fileUploaded = false;
    //     // let uri;
    //     // if (String(gallerydata[1]).includes("file:///") == false) {
    //     //   uri = "file:///" + gallerydata[1];
    //     // } else {
    //     //   uri = gallerydata[1];
    //     // }
    //     // if (gallerydata[0] != "0") {
    //     console.log(uri, "check uri ===================================>");
    //     this.validateFile(uri).then(result => {
    //       if (result[0] == "1") {
    //         let fileName = result[1];
    //         let fileType = result[2];
    //         // if (type != "2") {
    //         console.log(fileName, 'fileName', fileType, 'fileType');

    //         resolve(["1", fileName, fileType]);
    //         // }
    //         //  this.thumbnailUploaded = true;

    //         this.readFile(uri).then(filedata => {
    //           if (filedata[0] == "1") {
    //             // if (type != "1") {
    //             //   resolve([filedata[1], fileName, fileType]);
    //             // }
    //             // if(from=="ADVERTISEMENT" || from=="CONTRACT")
    //             //   return;
    //             this.uploadImagetoSever([filedata[1], fileName], "1");
    //           } else {
    //             resolve(filedata);
    //           }
    //         })
    //       } else {
    //         resolve(result);
    //       }
    //     })
    //     // } else {
    //     //   resolve(gallerydata);
    //     // }
    //     // })
    //   } catch (console) {
    //     resolve(["0", "Can't Fetch File"]);
    //   }
    // });
    return new Promise(async (resolve, reject) => {
      try {
        // this.openGallery(from).then(gallerydata => {
        this.uploadComplete = false;
        this.fileUploaded = false;
        // let uri;
        // if (String(gallerydata[1]).includes("file:///") == false) {
        //   uri = "file:///" + gallerydata[1];
        // } else {
        //   uri = gallerydata[1];
        // }
        // if (gallerydata[0] != "0") {
        console.log(uri, "check uri ===================================>");
        this.validateFile(uri).then(result => {
          console.log(result, "audio result <><><")
          if (result[0] == "1") {
            let fileName = result[1];
            let fileType = result[2];
            // if (type != "2") {
            // resolve(["1", fileName, fileType]);
            // }
            //  this.thumbnailUploaded = true;

            this.readFile(uri).then(filedata => {
              if (filedata[0] == "1") {
                // if (type != "1") {
                resolve([filedata[1], fileName, fileType]);
                // }
                // if(from=="ADVERTISEMENT" || from=="CONTRACT")
                //   return;
                //  this.uploadImagetoSever([filedata[1], fileName], "1", "AUDIO");
              } else {
                resolve(filedata);
              }
            })
          } else {
            resolve(result);
          }
        })
        // } else {
        //   resolve(gallerydata);
        // }
        // })
      } catch (console) {
        resolve(["0", "Can't Fetch File"]);
      }
    });
  }
}